import API from '../../../../libs/api';

const PROMPT_CLASS = 'LocationTitlePrompt';

export async function getLocationTitlePrompt(businessType, businessId, params) {
  return API.textCompletion(businessType, businessId, PROMPT_CLASS, params);
}
